import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { EIconButtons } from 'services/constants/iconsTypes';
import { TGetContractDocumentsRow } from 'redux/reducers/settings/types';

export type TContractDocumentTableRow = TGetContractDocumentsRow;

export const tableStructure: TTableStructure<keyof TContractDocumentTableRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Document type',
		selector: 'type',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Last updated at',
		// selector is not used for value, but required by type
		selector: 'id',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.RIGHT,
		value: (item: TContractDocumentTableRow) => item.versions[0]?.createdAt ?? '',
	},
	{
		name: 'Actions',
		noName: true,
		// special selector for action buttons
		selector: 'actions' as keyof TContractDocumentTableRow,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [{ name: 'Download', icon: EIconButtons.CLOUD_DOWNLOAD }],
	},
];
